<div class="sidebar-wrapper">
  <div class="logo" style="height: 62.45px; padding-top: 14px">
    <a routerLink="/home">
      <img
        alt="Logo Obras Públicas"
        src="./assets/img/mopc-v2.png"
        loading="lazy"
      />
    </a>
  </div>
  <ul class="nav">
    <li
      *ngFor="let menuItem of menuItems"
      routerLinkActive="active"
      class="{{ menuItem.Class }}"
    >
      <a [routerLink]="[menuItem.Url]">
        <i class="nc-icon {{ menuItem.Icon }}"></i>
        <p class="color-black-bold">{{ menuItem.Title }}</p>
      </a>
    </li>
  </ul>
</div>
